import { removeRedundantObjects } from 'utils/group';
import { listBrandGroups, getGroup, createGroup, deleteGroup, updateGroup } from '../thunks/organization-groups';

export const organizationGroupsReducers = (builder) => {
  builder
    .addCase(listBrandGroups.fulfilled, (state, action) => {
      const groups = action.payload;
      state.brandGroups.value = groups;
      state.brandGroups.loading = false;
    })
    .addCase(listBrandGroups.pending, (state) => {
      state.brandGroups.loading = true;
    })
    .addCase(listBrandGroups.rejected, (state) => {
      state.brandGroups.loading = false;
    });

  builder
    .addCase(getGroup.fulfilled, (state, action) => {
      const group = action.payload;
      const updateGroups = state.brandGroups.value.map((grp) => (grp.id === group.id ? { ...group } : grp));
      state.brandGroups.value = updateGroups;
      state.brandGroups.updating = false;
    })
    .addCase(getGroup.pending, (state) => {
      state.brandGroups.updating = true;
    })
    .addCase(getGroup.rejected, (state) => {
      state.brandGroups.updating = false;
    });

  builder
    .addCase(createGroup.fulfilled, (state, action) => {
      const group = action.payload;
      const updateGroups = [...state.brandGroups.value, group];
      state.brandGroups.value = removeRedundantObjects({ array: updateGroups, property: 'id' });
      state.brandGroups.updating = false;
    })
    .addCase(createGroup.pending, (state) => {
      state.brandGroups.updating = true;
    })
    .addCase(createGroup.rejected, (state) => {
      state.brandGroups.updating = false;
    });

  builder
    .addCase(updateGroup.fulfilled, (state, action) => {
      const group = action.payload;
      const updateGroups = state.brandGroups.value.map((g) => (g.id === group.id ? group : g));
      state.brandGroups.value = updateGroups;
      state.brandGroups.updating = false;
    })
    .addCase(updateGroup.pending, (state) => {
      state.brandGroups.updating = true;
    })
    .addCase(updateGroup.rejected, (state) => {
      state.brandGroups.updating = false;
    });

  builder
    .addCase(deleteGroup.fulfilled, (state, action) => {
      const groupId = action.payload;
      const updatedBrandGroups = state.brandGroups.value.filter((g) => g.id !== groupId);
      state.brandGroups.value = updatedBrandGroups;
      state.brandGroups.updating = false;
    })
    .addCase(deleteGroup.pending, (state) => {
      state.brandGroups.updating = true;
    })
    .addCase(deleteGroup.rejected, (state) => {
      state.brandGroups.updating = false;
    });
};
